const contactItems = [
  {
    icon: "ri-map-pin-line",
    label: "Address",
    value: "Ul. Prilep 76 str",
  },
  {
    icon: "ri-building-line",
    label: "City",
    value: "Varna",
  },
  {
    icon: "ri-mail-line",
    label: "Zip Code",
    value: "9010",
  },
  {
    icon: "ri-global-line",
    label: "Country",
    value: "Bulgaria",
  },
  {
    icon: "ri-mail-send-line",
    label: "Email",
    value: "help@melaood.com",
  },
  {
    icon: "ri-phone-line",
    label: "Phone",
    value: "+1 3612139973",
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-[#0f1117] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#2dd4bf] text-xs tracking-[4px] uppercase font-medium mb-4">
            Get In Touch
          </span>
          <h2 className="text-4xl md:text-5xl font-thin text-white leading-tight">
            Contact <span className="font-semibold">MELA OOD</span>
          </h2>
          <p className="text-white/50 mt-4 text-base max-w-md mx-auto">
            Reach out to our team for any inquiries about our iOS applications or partnership opportunities.
          </p>
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Left: Contact details */}
          <div className="bg-[#1a1d26] rounded-2xl p-10 border border-white/5">
            <h3 className="text-white font-semibold text-xl mb-8">Contact Information</h3>
            <ul className="space-y-6">
              {contactItems.map((item) => (
                <li key={item.label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#2dd4bf]/10 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#2dd4bf] text-lg`} />
                  </div>
                  <div>
                    <span className="block text-white/40 text-xs tracking-wider uppercase mb-1">
                      {item.label}
                    </span>
                    <span className="block text-white text-sm font-medium">{item.value}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Map / visual */}
          <div className="flex flex-col gap-6">
            {/* Location visual */}
            <div className="relative rounded-2xl overflow-hidden h-64 bg-[#1a1d26] border border-white/5">
              <img
                src="https://public.readdy.ai/ai/img_res/1fdd83fbd49bf1606305837b83b38d8d.jpg"
                alt="Varna, Bulgaria"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1117]/70 to-transparent" />
              <div className="absolute bottom-4 left-4">
                <span className="text-white font-semibold text-base">Varna, Bulgaria</span>
                <span className="block text-white/60 text-xs">Our headquarter location</span>
              </div>
            </div>

            {/* Quote block */}
            <div className="bg-[#1a1d26] rounded-2xl p-8 border border-white/5">
              <i className="ri-double-quotes-l text-[#2dd4bf] text-3xl mb-4 block" />
              <p className="text-white/70 text-sm leading-relaxed italic mb-4">
                &ldquo;We are committed to continuous improvement of our iOS products and always welcome feedback, questions, and collaboration from our users and partners worldwide.&rdquo;
              </p>
              <span className="text-white/40 text-xs tracking-wider uppercase">— MELA OOD Development Team</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer strip */}
      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/162592c8-e91d-4939-a85a-6f6f400e30e5.png"
            alt="MELA OOD"
            className="w-8 h-8 object-contain"
          />
          <span className="text-white/60 text-sm font-medium">MELA OOD</span>
        </div>
        <span className="text-white/30 text-xs">
          &copy; {new Date().getFullYear()} MELA OOD. All rights reserved. iOS Application Development.
        </span>
        <span className="text-white/30 text-xs">Varna, Bulgaria · 9010</span>
      </div>
    </section>
  );
}
